/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAccountPbIds$Request {
    accountId: number;
}

export interface GetAccountPbIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountPbIdsRequest = createAction<PayloadData<void, GetAccountPbIds$Request>>('GET_ACCOUNT_PB_IDS__GET_ACCOUNT_PB_IDS__REQUEST');
export const getAccountPbIdsSuccess = createAction<PayloadData<Array<string>, GetAccountPbIds$Request>>('GET_ACCOUNT_PB_IDS__GET_ACCOUNT_PB_IDS__SUCCESS');
export const getAccountPbIdsFailure = createAction<PayloadData<Error, GetAccountPbIds$Request, true>>('GET_ACCOUNT_PB_IDS__GET_ACCOUNT_PB_IDS__FAILURE');

export const getAccountPbIdsActions = [
    getAccountPbIdsRequest,
    getAccountPbIdsSuccess,
    getAccountPbIdsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountPbIds = (meta: GetAccountPbIds$Request, config?: GetAccountPbIds$Config) => {
    return {
        CALL_API: {
            types: getAccountPbIdsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/pb-ids`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

